// Normaliza um texto livre pra comparação/URL: remove acentos, minúsculas, hifens no lugar de espaços.
export const slugify = (value: string): string =>
  (value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
